var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.grid || !_vm.grid.id
        ? _c(
            "v-alert",
            {
              staticClass: "ma-4",
              attrs: { type: "info", text: "", dense: "" },
            },
            [
              _vm._v(
                " Salve a disciplina da turma para cadastrar horários fixos. "
              ),
            ]
          )
        : _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "", align: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "4" } },
                        [
                          _c("sys-select-day-of-week", {
                            attrs: {
                              model: _vm.form.day_of_week_id,
                              errors: _vm.errors.day_of_week_id,
                              error: !!_vm.errors.day_of_week_id,
                              label: "Dia da semana*",
                              dense: "",
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "day_of_week_id",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "4" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.hours,
                              "item-value": "id",
                              "item-text": "name",
                              label: "Horário (opcional)",
                              "error-messages": _vm.errors.hour_id,
                              clearable: "",
                              dense: "",
                              "no-data-text": "Nenhum horário cadastrado",
                            },
                            model: {
                              value: _vm.form.hour_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "hour_id", $$v)
                              },
                              expression: "form.hour_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex",
                          attrs: { cols: "12", sm: "4" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-2",
                              attrs: {
                                color: "primary",
                                small: "",
                                loading: _vm.saving,
                                disabled: !_vm.form.day_of_week_id,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.save()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.form.id ? "Salvar" : "Adicionar") +
                                  " "
                              ),
                              _c(
                                "v-icon",
                                { attrs: { right: "", small: "" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.form.id
                                        ? "mdi-content-save"
                                        : "mdi-plus"
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm.form.id
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { small: "", text: "" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      $event.stopPropagation()
                                      return _vm.resetForm()
                                    },
                                  },
                                },
                                [_vm._v("Cancelar")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-simple-table", {
                attrs: { dense: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function () {
                      return [
                        _c("thead", [
                          _c("tr", [
                            _c("th", { staticClass: "text-left" }, [
                              _vm._v("Dia da semana"),
                            ]),
                            _c("th", { staticClass: "text-left" }, [
                              _vm._v("Horário"),
                            ]),
                            _c("th", { staticClass: "text-left" }, [
                              _vm._v("Situação"),
                            ]),
                            _c("th", { staticClass: "text-center" }, [
                              _vm._v("Ações"),
                            ]),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          [
                            _vm._l(_vm.items, function (item) {
                              return _c("tr", { key: item.id }, [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.dayName(item.day_of_week_id))
                                  ),
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.hourName(item.hour_id))),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _vm.isBlocked(item)
                                      ? _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              "x-small": "",
                                              color: "orange",
                                              dark: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  left: "",
                                                },
                                              },
                                              [_vm._v("mdi-lock")]
                                            ),
                                            _vm._v(" Bloqueado "),
                                          ],
                                          1
                                        )
                                      : _c("span", [_vm._v("-")]),
                                  ],
                                  1
                                ),
                                _c(
                                  "td",
                                  { staticClass: "text-center" },
                                  [
                                    _vm.isBlocked(item)
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                color: "grey",
                                                              },
                                                            },
                                                            "v-icon",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _vm._v(
                                                            "mdi-lock-outline"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "Horário bloqueado, não pode ser alterado ou excluído. O registro foi incluído dinamicamente por outro processo"
                                              ),
                                            ]),
                                          ]
                                        )
                                      : [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                icon: "",
                                                "x-small": "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  $event.stopPropagation()
                                                  return _vm.edit(item)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "purple",
                                                  },
                                                },
                                                [_vm._v("mdi-pencil")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                icon: "",
                                                "x-small": "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  $event.stopPropagation()
                                                  return _vm.confirmDelete(item)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "red",
                                                  },
                                                },
                                                [_vm._v("mdi-delete")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                  ],
                                  2
                                ),
                              ])
                            }),
                            !_vm.items.length
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-center grey--text",
                                      attrs: { colspan: "4" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.loading
                                              ? "Carregando..."
                                              : "Nenhum horário fixo cadastrado para esta disciplina."
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("emc-alert-modal", {
                attrs: {
                  text: "Deseja excluir este horário fixo?",
                  disabled: _vm.deleting,
                  show: _vm.showDelete,
                },
                on: {
                  "update:show": function ($event) {
                    _vm.showDelete = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "actions",
                    fn: function () {
                      return [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "error",
                              loading: _vm.deleting,
                              disabled: _vm.deleting,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.destroy()
                              },
                            },
                          },
                          [
                            _vm._v("Excluir "),
                            _c("v-icon", { attrs: { right: "", dark: "" } }, [
                              _vm._v("mdi-delete"),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("emc-alert-snackbar", {
                attrs: {
                  show: !!_vm.message.length,
                  message: _vm.message,
                  color: _vm.error ? "error" : "success",
                },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }